export class BrowserExperienceConstants
{
    public static message:string = "We recommend new Microsoft Edge Browser for better performance.";
    public static timeLeft:number = 15*24*60*60*1000;
}